// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-9bb0684a] {\n  margin: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px)) 0 var(--magic-space--large, 32px);\n}", ""]);
// Exports
module.exports = exports;
